var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tab',{model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('el-tab-item',{attrs:{"title":"Distribution"}},[_c('br'),_c('kpi-value',{attrs:{"value":_vm.nrOfRides,"label":"Rides last 14 days"}}),_c('br'),_c('br'),_c('bar-graph',{attrs:{"height":200,"data":_vm.totAvgAngleD,"options":{
            scales: {
              xAxes: [{
                barPercentage: 1.3
              }],
              yAxes: [{
                ticks: {
                  callback: function(value, index, values) {
                    return value + '%';
                  }
                }
              }]
            }
          }}}),_c('br'),_c('br'),_c('bar-graph',{attrs:{"height":200,"data":_vm.totAlarmCount,"options":{
            scales: {
              xAxes: [{
                barPercentage: 1.3
              }],
              yAxes: [{
                ticks: {
                  callback: function(value, index, values) {
                    return value + '%';
                  }
                }
              }]
            }
          }}}),_c('br'),_c('br'),_c('bar-graph',{attrs:{"height":200,"data":_vm.nrOfRecords,"options":{
            scales: {
              xAxes: [{
                barPercentage: 1.3
              }],
              yAxes: [{
                ticks: {
                  callback: function(value, index, values) {
                    return value + '%';
                  }
                }
              }]
            }
          }}})],1),_c('el-tab-item',{attrs:{"title":"Rides"}},_vm._l((_vm.rides),function(ride){return _c('div',{key:ride.id},[_c('el-inline',{attrs:{"margin-top":"","nowrap":"","margin-bottom":""}},[_c('kpi-value',{attrs:{"value":ride.serialNumber,"label":"Serial number"}}),_c('kpi-value',{attrs:{"value":ride.data.length,"label":"Data points"}}),_c('kpi-value',{attrs:{"value":ride.header.tot_alarm_count,"label":"Total alarm count"}}),_c('kpi-value',{attrs:{"value":ride.header.tot_avg_angle_d,"label":"Average angle"}})],1),_c('el-inline',{attrs:{"margin-top":"","space-between":""}},[_c('i',[_vm._v(_vm._s(new Date(ride.timestamp).toLocaleString()))]),_c('i',{staticStyle:{"color":"#eee"}},[_vm._v(_vm._s(ride.id))])]),_c('el-collapse-header',{attrs:{"title":"Ride data"}},[_c('line-diagram',{attrs:{"height":100,"data":_vm.getRideLine(ride.data, 'avg_angle_d'),"options":{
              scales: {
                xAxes: [{
                  type: 'time',
                  time: {
                    unit: 'day'
                  }
                }]
              }
            }}}),_c('line-diagram',{attrs:{"height":100,"data":_vm.getRideLine(ride.data, 'alarm_count'),"options":{
              scales: {
                xAxes: [{
                  type: 'time',
                  time: {
                    unit: 'day'
                  }
                }]
              }
            }}})],1),_c('el-delimiter')],1)}),0)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }